export const musicTracks = [
  { title: "Canadian Club", file: "/music/canadian club.mp3" },
  { title: "Ghost Story", file: "/music/ghost story.mp3" },
  {
    title: "Grim Fandango (Early Version)",
    file: "/music/grim fandango early version.mp3",
  },
  { title: "Grim Fandango (w/ Bass)", file: "/music/grim fandango w bass.mp3" },
  { title: "Grim Fandango", file: "/music/grim fandango.mp3" },
  { title: "Hans & Frieda", file: "/music/hans & frieda.mp3" },
  { title: "Hey Bulldog", file: "/music/hey bulldog.mp3" },
  { title: "Oo De Lally", file: "/music/oo de lally.mp3" },
  { title: "Opening Montage", file: "/music/opening montage.mp3" },
  { title: "Oy Vey Experiment", file: "/music/oy vey experiment.mp3" },
  { title: "Ralph Wiggum", file: "/music/ralph wiggum.mp3" },
  { title: "Roadhouse", file: "/music/roadhouse.mp3" },
  { title: "Seaside Romance", file: "/music/seaside romance.mp3" },
  { title: "Setting Sail", file: "/music/setting sail.mp3" },
  { title: "Shakespeare", file: "/music/shakespeare.mp3" },
  { title: "Spaceman's Funeral", file: "/music/spaceman's funeral.mp3" },
  { title: "The Stallion Pt. 3", file: "/music/the stallion pt. 3.mp3" },
  { title: "Vermont", file: "/music/vermont.mp3" },
];
